// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2Wk6o","imageUploader":"EGiftCard_imageUploader__9Haj8"};